var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FFF6E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6942 20.0186L57.8131 28.6055C57.8842 28.6392 57.8809 28.7415 57.8078 28.7705L49.2679 32.1662C49.2459 32.175 49.2214 32.1747 49.1996 32.1655L39.6948 28.1394C39.6696 28.1287 39.6409 28.1301 39.6168 28.1431L30.6867 32.9877C30.6577 33.0034 30.6396 33.0338 30.6396 33.0668V45.5993C30.6396 45.6323 30.6578 45.6627 30.6869 45.6785L39.5527 50.4644C39.6126 50.4968 39.6854 50.4534 39.6854 50.3852V44.9822L39.7156 39.486C39.7158 39.4509 39.7364 39.4191 39.7684 39.4045L49.1948 35.1268C49.2194 35.1157 49.2476 35.1162 49.2718 35.1281L57.9498 39.4036C57.9805 39.4188 58 39.4501 58 39.4843V50.4813C58 50.5149 57.9812 50.5458 57.9513 50.5612L39.7256 59.9792C39.7003 59.9923 39.6703 59.9926 39.6448 59.9802L22.0505 51.3941C22.0196 51.379 22 51.3476 22 51.3132V28.7501C22 28.7158 22.0195 28.6845 22.0502 28.6694L39.6159 20.0192C39.6405 20.0071 39.6694 20.0069 39.6942 20.0186Z",
    fill: "url(#paint0_linear_1_10878)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6909 39.5334C39.6909 39.4897 39.7256 39.4539 39.7692 39.4525L39.8991 39.4481C39.9449 39.4466 39.9828 39.4832 39.9828 39.5289L40.0002 50.4514C40.0002 50.4962 39.9639 50.5326 39.9192 50.5326H39.7719C39.7272 50.5326 39.6909 50.4963 39.6909 50.4516V39.5334Z",
    fill: "#FFF6E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0152 42.8618L39.9942 39.4502C39.9342 39.4162 39.8599 39.4595 39.8599 39.5285V50.4534C39.8599 50.5158 39.9218 50.5593 39.9805 50.538L46.0015 48.3579C46.0371 48.345 46.0609 48.3111 46.0609 48.2732V42.9401C46.0609 42.9077 46.0434 42.8778 46.0152 42.8618Z",
    fill: "url(#paint1_linear_1_10878)",
    stroke: "white",
    strokeWidth: 0.09
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9976 39.3863C57.9976 39.3553 57.9799 39.327 57.952 39.3135L57.7578 39.2191C57.7043 39.1931 57.6419 39.2318 57.6414 39.2913L57.5482 50.3314C57.5479 50.3764 57.5842 50.4131 57.6292 50.4131H57.9166C57.9613 50.4131 57.9976 50.3768 57.9976 50.3321V39.3863Z",
    fill: "#FFF6E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4649 42.6509L57.5471 39.2383C57.6071 39.2046 57.6812 39.248 57.6812 39.3168V50.2429C57.6812 50.3052 57.6194 50.3486 57.5608 50.3276L51.4786 48.1468C51.4428 48.134 51.419 48.1001 51.419 48.0621V42.7294C51.419 42.6969 51.4365 42.6668 51.4649 42.6509Z",
    fill: "url(#paint2_linear_1_10878)",
    stroke: "white",
    strokeWidth: 0.09
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_10878",
    x1: 22,
    y1: 19.1667,
    x2: 57.3613,
    y2: 60.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C17014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF064"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_10878",
    x1: 40.0147,
    y1: 39.1755,
    x2: 44.4197,
    y2: 51.3974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C17014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF064"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_10878",
    x1: 57.189,
    y1: 38.9645,
    x2: 52.4545,
    y2: 50.8953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C17014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF064"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirect);
export default __webpack_public_path__ + "static/media/direct.c6d87ca0867c00c92b993cb331393b5a.svg";
export { ForwardRef as ReactComponent };